import { z } from 'zod'

const DecisionSchema = z.enum(['accepted', 'rejected']).nullable().optional()

export const FormSchema = z.object({
  decision: DecisionSchema,
  applicant_review_comment: z.string().nullable().optional(),
  status: z.number().nullable().optional(),
})

export type DecisionFormData = z.infer<typeof FormSchema>

export interface AppealPopupProps {
  payment_id: number;
  program_id: number;
  success: () => void;
}
